import { ApiClient } from './client';

export function fetchUserProfile(client: ApiClient, userId: string): Promise<any> {
  return client.get(`/prefs/${userId}`);
}

export function fetchUserPermissions(client: ApiClient): Promise<any> {
  return client.get('/ahiapi/userPermissions');
}
